// extracted by mini-css-extract-plugin
module.exports = {"loggedIn":"ProfileAvatarButton_loggedIn__J4sn_"};